<app-ui-modal [dialogClass]="'container modal-lg'">
    <div class="app-modal-header">
        <app-modal-header-content [title]="title">
        </app-modal-header-content>
    </div>

    <div class="app-modal-body">
        <app-user-form #userForm
            [isAddUser]="isAddUser"
            [account]="account"
            [user]="user">
        </app-user-form>
    </div>

    <div class="app-modal-footer">
        <app-modal-footer-content *ngIf="!isProcessingRequest"
            [confirmBtnText]="'Save'"
            [disabledConfirmBtn]="!userForm.isValid"
            [disabledConfirmBtnTitle]="'Form data is not valid!'"
            (confirmed)="saveData(userForm.getFormValues())">

            <button *ngIf="isAddUser"
                type="button"
                class="btn btn-primary"
                title="Save & Continue"
                [disabled]="!userForm.isValid"
                (click)="saveData(userForm.getFormValues(), true)">
                Save & Continue
            </button>
        </app-modal-footer-content>

        <div *ngIf="isProcessingRequest"
            class="modal-footer">
            <button class="btn btn-info"
                disabled>
                <span class="spinner-border spinner-border-sm"></span>
                Saving...
            </button>
        </div>
    </div>
</app-ui-modal>
